import { gql } from 'apollo-boost';

export const SET_GROQ_KEY = gql`
    mutation SetGroqKey($data: SetGroqKeyInput!) {
        setGroqKey(data: $data) {
            __typename
            ... on SetGroqKeySuccess {
                success
                status
            }
            ... on GroqKeyError {
                message
            }
            ... on InternalServerError {
                message
            }
        }
    }
`;
